import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { ReactNodeLike } from 'prop-types'
import React, { useMemo } from 'react'

import BaseDrawer from '@/components/drawers/base-drawer'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    zIndex: 100,
  },
  drawer: {
    width: 480,
    top: theme.menuHeight,
    height: `calc(100% - ${theme.menuHeight}px)`,
  },
}))

interface IDrawerWithOffset {
  open: boolean
  anchor: string
  withoutScrolling?: boolean
  children: ReactNodeLike
  styles: {
    wrapper: string,
    children: string,
  }
  className?: string
  dataQsId: string
  onClose: () => void
}

// Drawer with invisible backdrop and top offset equal to the new menu height
const DrawerWithOffset = (props: IDrawerWithOffset) => {
  const classes = useStyles()
  const { open, anchor, withoutScrolling, onClose, children, styles, className, dataQsId } = props
  const drawerStyles = useMemo(() => ({
    root: classes.root,
    drawer: classes.drawer,
    wrapper: styles?.wrapper,
    children: styles?.children,
  }), [styles, classes])

  return (
    <BaseDrawer
      hideBackdrop
      open={open}
      anchor={anchor}
      showCloseIcon={false}
      showHeader={false}
      withoutScrolling={withoutScrolling}
      withoutFooter={true}
      styles={drawerStyles}
      className={clsx(drawerStyles?.wrapper, className)}
      childrenClass={drawerStyles?.children}
      onClose={onClose}
      dataQsId={dataQsId}
    >
      {children}
    </BaseDrawer>
  )
}

export default DrawerWithOffset
